"use strict";
// Date Expression Operators: https://docs.mongodb.com/manual/reference/operator/aggregation/#date-expression-operators
Object.defineProperty(exports, "__esModule", { value: true });
exports.$dayOfYear = void 0;
var _internal_1 = require("./_internal");
/**
 * Returns the day of the year for a date as a number between 1 and 366 (leap year).
 * @param obj
 * @param expr
 */
function $dayOfYear(obj, expr, options) {
    return (0, _internal_1.getDayOfYear)((0, _internal_1.computeDate)(obj, expr, options));
}
exports.$dayOfYear = $dayOfYear;
